import { DocumentDownloadIcon } from '@heroicons/react/outline';
import useTranslation from 'next-translate/useTranslation';

export function Download({
  link,
  title,
  subtitle,
  size,
}: {
  link: string;
  title: string;
  subtitle?: string;
  size?: 'sm' | 'lg';
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col items-center  justify-start space-y-4  md:flex-row md:space-y-0 ${
        size == 'sm' ? 'py-2' : 'py-8 md:space-x-16'
      }`}
    >
      <a href={link} target='_blank' rel='noreferrer'>
        <DocumentDownloadIcon className='h-16 cursor-pointer text-primary' />
      </a>
      <div className='flex flex-col'>
        <h3
          className={`text-center md:text-left ${
            size == 'sm' ? 'subtitle' : 'title'
          }`}
        >
          {title}
        </h3>
        <a href={link} target='_blank' rel='noreferrer'>
          <h3
            className={`${
              size == 'sm' ? '' : 'subtitle'
            } cursor-pointer text-center text-primary md:text-left`}
          >
            {subtitle ?? t('common:Click here to download')}
          </h3>
        </a>
      </div>
    </div>
  );
}
